import { ProjectResource } from '../project/ProjectTypes.ts';
import { Technologies } from '../project/components/projectTechnologies/ProjectTechnologiesTypes.ts';
import { ProjectUrlsType } from '../project/components/projectUrls/ProjectUrlsTypes.ts';

/**
 * Technologies used in the Sorting Visualizer project.
 */
const TECHNOLOGIES: Technologies = [
    'React', 
    'SCSS', 
    'HTML5'
] as const;

/**
 * URLs for the Sorting Visualizer project.
 */
const PROJECT_URLS: ProjectUrlsType = {
    github: 'https://github.com/99061142/Sorting-Visualizer',
    live: 'https://99061142.github.io/Sorting-Visualizer/'
} as const;

const COMPLETION_YEAR: number = 2024;

export const sortingVisualizerResource: ProjectResource = {
    nl: {
        title: 'Sorting Visualizer',
        description: 'Een interactieve visualisatie tool voor sorteeralgoritmes die laat zien hoe verschillende algoritmes werken in real-time met behulp van een visuele interface.',
        technologies: {
            title: 'Gebruikte technologieën',
            usedTechnologies: TECHNOLOGIES
        },
        features: {
            title: 'Kenmerken',
            items: [
                'Visualisatie van meerdere sorteeralgoritmes',
                'Aanpasbare array grootte en snelheid',
                'Real-time animaties'
            ]
        },
        urls: PROJECT_URLS,
        status: {
            status: 'Dit project is voltooid in',
            completionMonth: 'februari',
            completionYear: COMPLETION_YEAR,
            isFinished: true
        }
    },
    en: {
        title: 'Sorting Visualizer',
        description: 'An interactive visualization tool for sorting algorithms that demonstrates how different algorithms work in real-time with a visual interface.',
        technologies: {
            title: 'Used technologies',
            usedTechnologies: TECHNOLOGIES
        },
        features: {
            title: 'Features',
            items: [
                'Visualization of multiple sorting algorithms',
                'Customizable array size and speed',
                'Real-time animations'
            ]
        },
        urls: PROJECT_URLS,
        status: {
            status: 'This project was completed at',
            completionMonth: 'February',
            completionYear: COMPLETION_YEAR,
            isFinished: true
        }
    }
} as const;